import { render, staticRenderFns } from "./importFile.vue?vue&type=template&id=4466c579&scoped=true"
import script from "./importFile.vue?vue&type=script&lang=js"
export * from "./importFile.vue?vue&type=script&lang=js"
import style0 from "./importFile.vue?vue&type=style&index=0&id=4466c579&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4466c579",
  null
  
)

export default component.exports